import { useEffect, useState } from 'react';
import { PiQuestionDuotone } from 'react-icons/pi';

import { Button, ButtonProps } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { isEditableTarget } from '../../utils/index.js';
import { KeyboardShortcutsDialog } from '../KeyboardShortcutsDialog/index.js';

export interface KeyboardShortcutsControlsProps {
  buttonSize?: ButtonProps['size'];
}

/**
 * Help button that opens the "Keyboard shortcuts" dialog, plus a global
 * `?` listener that opens the same dialog. Mirrors the self-contained pattern
 * used by `HistoryControls` (button + listener co-located).
 */
export const KeyboardShortcutsControls: React.FC<KeyboardShortcutsControlsProps> = ({
  buttonSize = 'medium',
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useEventCallback(() => setOpen(true));
  const handleClose = useEventCallback(() => setOpen(false));

  useEffect(() => {
    const keydown = (e: KeyboardEvent) => {
      if (e.key !== '?' || e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }
      if (isEditableTarget(e.target)) {
        return;
      }
      e.preventDefault();
      setOpen((prev) => !prev);
    };

    window.addEventListener('keydown', keydown);

    return () => window.removeEventListener('keydown', keydown);
  }, []);

  return (
    <>
      <Button size={buttonSize} onClick={handleOpen}>
        <PiQuestionDuotone />
      </Button>
      <KeyboardShortcutsDialog open={open} onClose={handleClose} />
    </>
  );
};
